import React from 'react';
import { homeServices } from '../../data/home';
export function HomeServicesRow() {
  return <section aria-labelledby="home-services-title" className="relative z-10 -mt-24 px-5 pb-20 sm:px-8" data-id="element-345" data-mp="q9is2bs3rrjs">
      <div className="mx-auto max-w-7xl rounded-[1.75rem] bg-white p-6 shadow-[0_30px_60px_-30px_rgba(38,58,41,0.45)] ring-1 ring-forest/[0.06] sm:p-8" data-id="element-346" data-mp="v8vfaxmvz0mw">
        <h2 id="home-services-title" className="text-center text-xs font-bold uppercase tracking-[0.22em] text-olive" data-id="element-347" data-mp="z8mbjgv6m8yt">
          Our Lawncare Services
        </h2>
        <ul className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-7" data-id="element-348" data-mp="7kc7skbnurvv">
          {homeServices.map(({
          label,
          icon: Icon
        }) => <li key={label} className="flex flex-col items-center gap-3 rounded-2xl px-2 py-4 text-center transition-colors hover:bg-cream" data-id="element-349" data-mp="bjb8fsqd02hi">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-olive-50 text-olive ring-2 ring-[#E3C77F]/60" data-id="element-350" data-mp="3fyb2limwc77s">
                <Icon className="h-6 w-6" strokeWidth={1.75} aria-hidden="true" data-id="element-351" data-mp="3jz4ns48yf7wz" />
              </span>
              <span className="text-[14px] font-semibold leading-snug text-forest" data-id="element-352" data-mp="22f2v043uuz5b">{label}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}